import useModal from '@/common/hooks/useModal';
import { useQuery } from '@tanstack/react-query';
import { versionNotificationQueryOptions } from '../../queries/versionNotification/versionNotificationQueryOptions';
import VersionNotificationModal from '../modals/VersionNotificationModal';

const VERSION_NOTIFICATION_ID = 'version_notification_id';

export default function VersionNotification() {
  const {
    open: isVersionNotifOpen,
    closeModal: closeVersionNotif,
    openModal: openVersionNotif,
  } = useModal();

  const { data: NotificationData } = useQuery(
    versionNotificationQueryOptions({
      onSuccess: (NotificationData) => {
        const alert = NotificationData?.alert;

        if (!alert) return;

        const currentAlertId = String(alert.id);
        const savedAlertId = localStorage.getItem(VERSION_NOTIFICATION_ID);

        if (!savedAlertId || savedAlertId !== currentAlertId) {
          localStorage.setItem(VERSION_NOTIFICATION_ID, currentAlertId);

          openVersionNotif();
        }
      },
    }),
  );

  return (
    <>
      {isVersionNotifOpen && (
        <VersionNotificationModal
          open={isVersionNotifOpen}
          closeModal={closeVersionNotif}
          NotificationData={NotificationData}
        />
      )}
    </>
  );
}
